export default __webpack_public_path__ + "static/media/roadmapBall.9a864186.png";